<template>
  <div class="side-nav">
    <div v-for="section in centerSections" :key="section">
      <template v-if="section === 'orders'">
        <span>订单中心</span>
        <router-link v-if="isSecondaryUser" to="/orders">我的订单</router-link>
        <router-link v-if="isIntegralUser" to="/integralOrders">积分订单</router-link>
      </template>
      <template v-else-if="section === 'assets'">
        <span>资产中心</span>
        <router-link v-if="isSecondaryUser" to="/coupons">我的优惠券</router-link>
        <router-link v-if="isIntegralUser" to="/integralRecord">积分明细</router-link>
      </template>
      <template v-else-if="section === 'integral'">
        <span>积分中心</span>
        <router-link to="/score">积分商城</router-link>
      </template>
    </div>
    <!--
    <div v-if="false">
      <span>关注中心</span>
      <a href="">我的收藏</a>
      <a href="">浏览历史</a>
    </div>
    -->
    <div>
      <span>账户设置</span>
      <router-link to="/baseInfo">账户信息</router-link>
      <router-link v-if="showAddress" to="/address">收货地址</router-link>
      <!-- <a href="">编辑绑定关系</a> -->
      <!-- <a href="">账户安全</a> -->
      <!-- <a href="" v-if="false">二级账户管理</a> -->
      <!-- <router-link to="/regProgress" v-if="false">注册审核进度</router-link> -->
    </div>
    <!--
    <div v-if="false">
      <span>消息中心</span>
      <a href="">消息</a>
    </div>
    -->
  </div>
</template>

<script>
import currentUser from '@/mixins/current-user'

export default {
  mixins: [currentUser],
  name: 'side-nav',
  computed: {
    isSecondaryUser () {
      return this.isLoggedIn && Number(this.currentUser.dealerLevel) === 2
    },
    centerSections () {
      return this.isIntegralUser ? ['integral', 'orders', 'assets'] : ['orders', 'assets']
    },
    showAddress () {
      const user = this.currentUser
      const distributor = user && (user.distributor || user)
      const loginName = distributor && distributor.loginName
      if (this.isSecondaryUser) {
        return Boolean(distributor)
      }
      return this.isIntegralUser && Boolean(distributor) && Boolean(loginName) &&
        !loginName.startsWith('504639_') && !loginName.startsWith('139366_')
    }
  }
}
</script>

<style scoped="scoped" lang="less">

</style>
